import { Entry } from "interfaces/entry";
import { POOL_STATUS } from "utils/constants";
import { ContestantResponse } from "interfaces/contestant-response";
import { ContestantId } from "interfaces/contestant-result-places";
import SingleSelectionSettledEntryItem
  from "components/pool-details/entries/single-selection-entry-list/single-selection-settled-entry-item";
import SingleSelectionOpenEntryItem
  from "components/pool-details/entries/single-selection-entry-list/single-selection-open-entry-item";

interface Props {
  entries: Entry[];
  contestants: ContestantResponse[];
  selectBet: any;
  winningContestantIds: ContestantId[];
  poolStatus: number;
  selectedEntry: Entry | undefined;
  contestEntryId?: string;
  pickedContestantIds?: Set<string>;
}

const getItem = (poolStatus: number) => {
  switch (poolStatus) {
    case POOL_STATUS.PENDING:
      return SingleSelectionSettledEntryItem;
    case POOL_STATUS.OPEN:
      return SingleSelectionOpenEntryItem;
    case POOL_STATUS.LIVE:
      return SingleSelectionSettledEntryItem;
    case POOL_STATUS.SETTLED:
      return SingleSelectionSettledEntryItem;
    default:
      return SingleSelectionSettledEntryItem;
  }
};

const moveWinnerEntryToTheTop = (entries: Entry[], winningEntryIds: string[]) => {
  entries.forEach((entry: Entry, index: number) => {
    if (winningEntryIds.includes(entry.contestant_id)) {
      entries.splice(index, 1);
      entries.unshift(entry);
    }
  });
  return entries;
};

const SingleSelectionEntryList = ({
                                    entries,
                                    contestants,
                                    selectBet,
                                    winningContestantIds,
                                    poolStatus,
                                    selectedEntry,
                                    contestEntryId,
                                    pickedContestantIds
                                  }: Props) => {
  const totalSeedDistribution = contestants.reduce((acc, item) => {
    return acc + item.seed_distribution;
  }, 0);

  const Item = getItem(poolStatus);

  // Filter entries to only show win bet type (single contestant entries)
  const winEntries = entries.filter((entry) => entry.pool_type === "win");

  const sortedEntries = winningContestantIds
    ? moveWinnerEntryToTheTop(winEntries, winningContestantIds)
    : winEntries;

  return (
    <>
      {sortedEntries.map((entry: Entry) => {
        const projectedWin =
          entry.seed_distribution / totalSeedDistribution || 0;
        const isSelected =
          !!selectedEntry &&
          entry.pool_entry_id === selectedEntry.pool_entry_id;

        return (
          <Item
            key={entry.pool_entry_id}
            selectBet={selectBet}
            item={entry}
            winner={winningContestantIds.includes(entry.contestant_id)}
            isSelected={isSelected}
            projectedWin={projectedWin}
            contestEntryId={contestEntryId}
            alreadyPicked={pickedContestantIds?.has(entry.contestant_id) ?? false}
          />
        );
      })}
    </>
  );
};

export default SingleSelectionEntryList;
